<template>
  <div>
    <!-- <head-vue></head-vue> -->
    <head-new></head-new>
    <router-view :key="$route.path" v-slot="{Component} ">
         <transition name="contentMove" appear>
            <component :is="Component"/>
        </transition>
    </router-view>
    <!-- <router-view :key="$route.path"/> -->
    <!-- <contact-us></contact-us> -->
    <foot-vue></foot-vue>
  </div>
</template>

<script>
// import HeadVue from '@components/layout/head.vue';
import HeadNew from '@components/layout/headNew.vue';
import ContactUs from '@/components/layout/contactUs.vue';
import FootVue from '@components/layout/foot.vue';
export default {
    mixins: [],
    components: {
        ContactUs,
        FootVue,
        HeadNew
    },
    data() {
        return {
            userId: "",
            openInfo: false,
        };
    },
    mounted() {
    },
    methods: {

    },

};
</script>

<style>
/* 类名要对应回 name 的属性值 */
.contentMove-enter-active {
    animation: contentMove 1s;
}

.contentMove-leave-active {
    animation: contentMove 1s reverse;
}

@keyframes contentMove {
    from {
        transform: translateX(100px);
    }

    to {
        transform: translate(0);
    }
}

</style>